import { createContext } from "react";

const RecetaExpedienteContext = createContext();

export default RecetaExpedienteContext;
